import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { Wineries } from './pages/Wineries';
import { Restaurants } from './pages/Restaurants';
import { SocialClubs } from './pages/SocialClubs';
import { EventVenues } from './pages/EventVenues';
import { Philanthropy } from './pages/Philanthropy';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="w-full h-full overflow-x-hidden" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="/services" element={<Services data-id="element-9" />} data-id="element-8" />
          <Route path="/blog" element={<Blog data-id="element-11" />} data-id="element-10" />
          <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
          <Route path="/partnerships/wineries" element={<Wineries data-id="element-15" />} data-id="element-14" />
          <Route path="/partnerships/restaurants" element={<Restaurants data-id="element-17" />} data-id="element-16" />
          <Route path="/partnerships/social-clubs" element={<SocialClubs data-id="element-19" />} data-id="element-18" />
          <Route path="/partnerships/event-venues" element={<EventVenues data-id="element-21" />} data-id="element-20" />
          <Route path="/partnerships/philanthropy" element={<Philanthropy data-id="element-23" />} data-id="element-22" />
        </Routes>
      </div>
    </BrowserRouter>;
}